module.exports = __webpack_public_path__ + "img/blog6-logo-10.d96fb258.webp";